import { clsx } from 'clsx';
import React from 'react';
import styles from './householdsize-image.module.scss';

export const HouseholdsizeImage: React.FC<{ className: string }> = ({ className }) => (
  <svg viewBox="0 0 508 299" fill="none" className={clsx(styles.image, styles[className])}>
    <g id="lightFirst" className={clsx(styles.light, styles.lightFirst)}>
      <path
        className="cable"
        d="M70 124L70 23"
        stroke="#000207"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g className={styles.bulb}>
        <path
          d="M81 60c1.816 13.093 14 29.707 14 39.46C95 114.114 83.81 126 70 126c-13.804 0-25-11.879-25-26.54C45 89.63 56.797 73.093 59 60"
          fill="#fff"
        />
        <path
          d="M81 60c1.816 13.093 14 29.707 14 39.46C95 114.114 83.81 126 70 126c-13.804 0-25-11.879-25-26.54C45 89.63 56.797 73.093 59 60"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M58 61h24V44H58v17Z"
          fill="#fff"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M69.432 112.117c-6.188 0-11.209-5.185-11.209-11.58"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M70 60.131v10.846"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
      </g>
      <g className={styles.shine}>
        <path
          id="Vector_13"
          d="M70 137L70 152"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_14"
          d="M33 137L44.0137 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_15"
          d="M107.014 137L96 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <g id="lightSecond" className={clsx(styles.light, styles.lightSecond)}>
      <path
        className="cable"
        d="M162 87L162 23"
        stroke="#000207"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g className={styles.bulb}>
        <path
          d="M173 60c1.816 13.093 14 29.707 14 39.46 0 14.654-11.19 26.54-25 26.54-13.804 0-25-11.879-25-26.54 0-9.83 11.797-26.367 14-39.46"
          fill="#fff"
        />
        <path
          d="M173 60c1.816 13.093 14 29.707 14 39.46 0 14.654-11.19 26.54-25 26.54-13.804 0-25-11.879-25-26.54 0-9.83 11.797-26.367 14-39.46"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M150 61h24V44h-24v17Z"
          fill="#fff"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M161.432 112.117c-6.188 0-11.209-5.185-11.209-11.58"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M162 60.131v10.846"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
      </g>
      <g className={styles.shine}>
        <path
          id="Vector_21"
          d="M162 136L162 152"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_22"
          d="M125 137L136.014 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_23"
          d="M199.014 137L188 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <g id="lightThird" className={clsx(styles.light, styles.lightThird)}>
      <path
        className="cable"
        d="M254 125L254 23"
        stroke="#000207"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g className={styles.bulb}>
        <path
          d="M265 60c1.816 13.093 14 29.707 14 39.46 0 14.654-11.19 26.54-25 26.54-13.804 0-25-11.879-25-26.54 0-9.83 11.797-26.367 14-39.46"
          fill="#fff"
        />
        <path
          d="M265 60c1.816 13.093 14 29.707 14 39.46 0 14.654-11.19 26.54-25 26.54-13.804 0-25-11.879-25-26.54 0-9.83 11.797-26.367 14-39.46"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M242 61h24V44h-24v17Z"
          fill="#fff"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M253.432 112.117c-6.188 0-11.209-5.185-11.209-11.58"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M254 60.131v10.846"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
      </g>
      <g className={styles.shine}>
        <path
          id="Vector_29"
          d="M254 136L254 152"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_30"
          d="M217 137L228.014 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_31"
          d="M291.014 137L280 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <g id="lightFourth" className={clsx(styles.light, styles.lightFourth)}>
      <path
        className="cable"
        d="M346 87L346 23"
        stroke="#000207"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g className={styles.bulb}>
        <path
          d="M357 60c1.816 13.093 14 29.707 14 39.46 0 14.654-11.19 26.54-25 26.54-13.804 0-25-11.879-25-26.54 0-9.83 11.797-26.367 14-39.46"
          fill="#fff"
        />
        <path
          d="M357 60c1.816 13.093 14 29.707 14 39.46 0 14.654-11.19 26.54-25 26.54-13.804 0-25-11.879-25-26.54 0-9.83 11.797-26.367 14-39.46"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M334 61h24V44h-24v17Z"
          fill="#fff"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M345.432 112.117c-6.188 0-11.209-5.185-11.209-11.58"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M346 60.131v10.846"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
      </g>
      <g className={styles.shine}>
        <path
          id="Vector_37"
          d="M346 136L346 152"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_38"
          d="M309 137L320.014 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_39"
          d="M383.014 137L372 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <g id="lightFifth" className={clsx(styles.light, styles.lightFifth)}>
      <path
        className="cable"
        d="M438 107L438 23"
        stroke="#000207"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g className={styles.bulb}>
        <path
          d="M449 60c1.816 13.093 14 29.707 14 39.46 0 14.654-11.19 26.54-25 26.54-13.804 0-25-11.879-25-26.54 0-9.83 11.797-26.367 14-39.46"
          fill="#fff"
        />
        <path
          d="M449 60c1.816 13.093 14 29.707 14 39.46 0 14.654-11.19 26.54-25 26.54-13.804 0-25-11.879-25-26.54 0-9.83 11.797-26.367 14-39.46"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M426 61h24V44h-24v17Z"
          fill="#fff"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M437.432 112.117c-6.188 0-11.209-5.185-11.209-11.58"
          stroke="#000207"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
        <path
          d="M438 60.131v10.846"
          stroke="#000"
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinejoin="round"
        />
      </g>
      <g className={styles.shine}>
        <path
          id="Vector_5"
          d="M438 136L438 152"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M401 137L412.014 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M475.014 137L464 126"
          stroke="#000207"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <g clipPath="url(#a)" stroke="#000" strokeWidth={2} strokeLinejoin="round">
      <path fill="#DDD" d="M18 1h472v21H18z" />
      <path fill="#000" d="M241 22h26v13h-26z" />
    </g>
    <path stroke="#000" strokeWidth={2} strokeLinejoin="round" d="M18 1h472v280H18z" />
    <path
      fill="#D9D9D9"
      stroke="#000"
      strokeWidth={2}
      strokeLinejoin="round"
      d="M1.293 281.211h505.416v16.708H1.293z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(18 1.352)" d="M0 0h472v279.858H0z" />
      </clipPath>
    </defs>
  </svg>
);
